// Copyright (c) 2016 Deere & Company

import DealerSearchModal, { getDefaultState as getDealerSearchModalDefaultState } from '../state/dealer-search-modal';
import actions from '../../../../sharedmodules/actions-list';

const updateDealerSearchModalVisibility = (state, action) => {

    const toggleVisibility = !action.isVisible;

    return DealerSearchModal.update(state, {
        isVisible: {
            $set: toggleVisibility,
        },
    });

};

export default (state = getDealerSearchModalDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_DEALER_SEARCH_MODAL_VISIBILITY]: updateDealerSearchModalVisibility,
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};
